/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Featured_DescInputs */

const en_directory_home_featured_desc = /** @type {(inputs: Directory_Home_Featured_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High-signal AI tools selected to help you find the perfect solutions for your workflow.`)
};

const zh_directory_home_featured_desc = /** @type {(inputs: Directory_Home_Featured_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高信号 AI 工具，帮你快速找到适合的解决方案。`)
};

/**
* | output |
* | --- |
* | "High-signal AI tools selected to help you find the perfect solutions for your workflow." |
*
* @param {Directory_Home_Featured_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_featured_desc = /** @type {((inputs?: Directory_Home_Featured_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Featured_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_featured_desc(inputs)
	return zh_directory_home_featured_desc(inputs)
});
export { directory_home_featured_desc as "directory.home.featured_desc" }